"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAndTrack = exports.loadSuccess = exports.loadError = exports.loading = void 0;
var actions = require("./actionTypes");
exports.loading = function (request) { return ({ type: actions.LOADING, request: request }); };
exports.loadError = function (request) { return ({ type: actions.LOAD_ERROR, request: request }); };
exports.loadSuccess = function (request) { return ({ type: actions.LOAD_SUCCESS, request: request }); };
exports.loadAndTrack = function (dispatch, request, promise) {
    dispatch(exports.loading(request));
    return promise
        .then(function (result) {
        dispatch(exports.loadSuccess(request));
        return result;
    })
        .catch(function (error) {
        dispatch(exports.loadError(request));
        throw error;
    });
};
